import http from '@/utils/http.js' // 引入封装的request.js文件
import common from '@/config/common.js'

// 查询字典数据列表
// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
  return http.request({
    url: '/papi/dict/data/type/' + dictType,
    method: 'get'
  })
}
